export default __webpack_public_path__ + "static/media/failed_popup_dark_version.5914a9e6.png";